import { render, staticRenderFns } from "./CuponList.vue?vue&type=template&id=198531c4&"
import script from "./CuponList.vue?vue&type=script&lang=js&"
export * from "./CuponList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports